import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" This user is already in the group. ");

var _hoisted_2 = {
  class: "text-end"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add this user ");

import { ref } from "vue";
import { useMessage } from "naive-ui";
import { handleError } from "@/utils/errors";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import UserLookup from "@/components/users/UserLookup.vue";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    groupId: null,
    focus: {
      type: Boolean,
      default: false
    },
    excluded: {
      default: function _default() {
        return [];
      }
    }
  },
  emits: ["search", "link"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var messageAPI = useMessage();
    var LoaderState = LoaderStateEnum;
    var loader = ref(LoaderStateEnum.Idle);
    var error = ref("");

    var link = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader.value = LoaderStateEnum.Loading;
                _context.prev = 1;
                _context.next = 4;
                return http.put("/groups/".concat(props.groupId, "/users"), {
                  usersIds: [user.id]
                });

              case 4:
                emit("link", user);
                loader.value = LoaderStateEnum.Loaded;
                messageAPI.success("The user has been invited");
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                _context.next = 13;
                return handleError(_context.t0, {
                  placeholder: "There was an error during the addition process"
                });

              case 13:
                error.value = _context.sent;
                loader.value = LoaderStateEnum.Failed;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function link(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_n_alert = _resolveComponent("n-alert");

      var _component_n_collapse_transition = _resolveComponent("n-collapse-transition");

      var _component_n_button = _resolveComponent("n-button");

      return _openBlock(), _createBlock(UserLookup, {
        loader: loader.value,
        focus: __props.focus,
        onSearch: _cache[0] || (_cache[0] = function (query) {
          return emit('search', query);
        })
      }, {
        actions: _withCtx(function (_ref3) {
          var user = _ref3.user;
          return [_createVNode(_component_n_collapse_transition, {
            show: loader.value === _unref(LoaderState).Failed
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_n_alert, {
                type: "error",
                class: "white-space-pre-line mb-3",
                "show-icon": false
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(error.value), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["show"]), loader.value === _unref(LoaderState).Idle && __props.excluded.some(function (u) {
            return u.id === user.id;
          }) ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            type: "error",
            "show-icon": false,
            class: "mb-3"
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_n_button, {
            type: "primary",
            disabled: loader.value === _unref(LoaderState).Loading || __props.excluded.some(function (u) {
              return u.id === user.id;
            }),
            onClick: function onClick($event) {
              return link(user);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 2
          }, 1032, ["disabled", "onClick"])])];
        }),
        _: 1
      }, 8, ["loader", "focus"]);
    };
  }
});